import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const CloseGeneratorDrawerIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="50" cy="50" r="50" fill={fillColor || '#2B2D2F'} />
      <rect x="63.4351" y="35.1519" width="2" height="40" transform="rotate(45 63.4351 35.1519)" fill={fillColor || 'white'} />
      <rect x="35.1509" y="36.5659" width="2" height="40" transform="rotate(-45 35.1509 36.5659)" fill={fillColor || 'white'} />
    </svg>
  );
};

export { CloseGeneratorDrawerIcon };
